import { Button } from '@neo/index'
import { cn } from '@neo/lib/utils'

interface TransferButtonsProps {
  onTransfer: (type: 'warm' | 'cold') => void
  isDisabled: boolean
  prefix?: string
  alwaysVisible?: boolean
}

export const TransferButtons = ({
  onTransfer,
  isDisabled,
  prefix = '',
  alwaysVisible = false,
}: TransferButtonsProps) => (
  <div
    className={cn(
      'group-hover:flex gap-2 items-center ml-auto hidden',
      alwaysVisible && 'flex ml-0',
    )}
  >
    <Button
      size="xs"
      disabled={isDisabled}
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation()
        onTransfer('warm')
      }}
      data-testid={`button-warm-${prefix}transfer`}
    >
      Warm
    </Button>
    <Button
      size="xs"
      variant="outline"
      disabled={isDisabled}
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation()
        onTransfer('cold')
      }}
      data-testid={`button-cold-${prefix}transfer`}
    >
      Cold
    </Button>
  </div>
)
